import { colorsPalettes } from "@similarweb/styles";
import { Badge, Card, ProgressBar } from "@similarweb/ui-components";
import { Box, Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import {
    HEALTH_STATUS_COLORS,
    type AdoptionHealthStatus,
} from "app/pages/sales-intelligence/modules/extension-management/services/adoptionVariant";

type BottomStat = {
    label: string;
    value: number;
};

type StatCardProps = {
    title: string;
    percentage: number;
    description: string;
    status: AdoptionHealthStatus;
    badgeText: string;
    bottomStats: BottomStat[];
    dataAutomation: string;
};

export const ExtensionAdoptionStatsCard = ({
    title,
    percentage,
    description,
    status,
    badgeText,
    bottomStats,
    dataAutomation,
}: StatCardProps) => {
    const colors = HEALTH_STATUS_COLORS[status];

    return (
        <Card
            gap="16px"
            flex="1 1 0%"
            minWidth="0"
            padding="20px 24px"
            data-automation={dataAutomation}
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
            >
                <Text
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon["500"]}
                >
                    {title}
                </Text>
                <Badge
                    type="custom"
                    color={colors.badge}
                    bgColor={colors.badgeBg}
                >
                    {badgeText}
                </Badge>
            </Flex>

            <Stack gap="8px">
                <Text
                    fontVariant="h3"
                    color={colorsPalettes.carbon["400"]}
                >
                    {percentage}%
                </Text>
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon["300"]}
                >
                    {description}
                </Text>
                <ProgressBar
                    values={[Math.min(percentage / 100, 1)]}
                    colorSet={[colors.bar]}
                    height="6px"
                />
            </Stack>

            <Box
                width="100%"
                height="1px"
                background={colorsPalettes.carbon["50"]}
            />

            <Flex justifyContent="space-between">
                {bottomStats.map((stat) => (
                    <Stack
                        key={stat.label}
                        gap="4px"
                    >
                        <Text
                            fontVariant="caption"
                            color={colorsPalettes.carbon["300"]}
                        >
                            {stat.label}
                        </Text>
                        <Text
                            fontVariant="subtitle1"
                            color={colorsPalettes.carbon["500"]}
                        >
                            {stat.value}
                        </Text>
                    </Stack>
                ))}
            </Flex>
        </Card>
    );
};
